export default __webpack_public_path__ + "static/media/nft-3.d99a31c5.gif";